import React, { useRef, useState, useEffect } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import axios from "axios";
import { TextField, Button, Box, Typography, Container } from "@mui/material";
import apiClient from "../components/apiClient";
import { ToastContainer, toast } from "react-toastify"; // Make sure to import Toastify

const OtpVerification = () => {
  const { state } = useLocation();
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [errorMessage, setErrorMessage] = useState("");
  const [timer, setTimer] = useState(60); // Timer state for countdown
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const location = useLocation();
  const email = location.state?.email;
  const [message, setMessage] = useState("");

  // Start countdown timer when OTP page is loaded
  useEffect(() => {
    if (timer === 0) return;
    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  console.log(localStorage.getItem("userId"));

  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    if (/^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to next field if not last
      if (index < otp.length - 1) {
        inputRefs.current[index + 1]?.focus();
      }

      // Auto verify if all digits filled
      if (newOtp.every((digit) => digit !== "")) {
        handleVerifyOtp(newOtp.join(""));
      }
    } else if (value === "") {
      // Clear value
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newOtp = [...otp];

      if (otp[index] === "") {
        // Move to previous if current already empty
        if (index > 0) {
          inputRefs.current[index - 1]?.focus();
          newOtp[index - 1] = "";
          setOtp(newOtp);
        }
      } else {
        // Just clear current
        newOtp[index] = "";
        setOtp(newOtp);
      }
    }
  };

  // const handleVerifyOtp = async (otpString) => {
  //   try {
  //     const response = await apiClient.post("/user/verify-otp", {
  //       email: state.email,
  //       otp: otpString,
  //     });

  //     if (response.data && response.data.token) {
  //       localStorage.setItem("token", response.data.token);
  //       navigate("/"); // Redirect to home after successful OTP verification
  //     } else {
  //       setErrorMessage("OTP tidak valid atau telah kedaluwarsa.");
  //     }
  //   } catch (error) {
  //     console.error("Error verifying OTP:", error);
  //     setErrorMessage("Terjadi kesalahan saat memverifikasi OTP.");
  //   }
  // };

  // const handleVerifyOtp = async (otpString) => {
  //   const emailToVerify = state?.email || localStorage.getItem("pendingEmail");

  //   if (!emailToVerify) {
  //     setErrorMessage("Email tidak ditemukan. Silakan daftar ulang.");
  //     return;
  //   }

  //   try {
  //     const response = await apiClient.post("/user/verify-otp", {
  //       email: emailToVerify,
  //       otp: otpString,
  //     });

  //     if (response.data && response.data.token) {
  //       localStorage.setItem("token", response.data.token);
  //       localStorage.removeItem("pendingEmail");
  //       navigate("/"); // Success — go to homepage
  //     } else {
  //       setErrorMessage("OTP tidak valid atau telah kedaluwarsa.");
  //     }
  //   } catch (error) {
  //     console.error("Error verifying OTP:", error);
  //     setErrorMessage("Terjadi kesalahan saat memverifikasi OTP.");
  //   }
  // };

  // const handleVerifyOtp = async (otpString) => {
  //   const emailToVerify = state?.email || localStorage.getItem("pendingEmail");
  //   const formData = JSON.parse(localStorage.getItem("pendingRegisterData"));

  //   if (!emailToVerify || !formData) {
  //     setErrorMessage("Data tidak lengkap. Silakan daftar ulang.");
  //     return;
  //   }

  //   try {
  //     // ✅ Step 1: Verify OTP
  //     const otpResponse = await apiClient.post("/user/verify-otp", {
  //       email: emailToVerify,
  //       otp: otpString,
  //     });

  //     if (otpResponse.data?.success) {
  //       // ✅ Step 2: Register user now
  //       const registerResponse = await apiClient.post(
  //         "/user/register",
  //         formData
  //       );

  //       if (
  //         registerResponse.data &&
  //         registerResponse.data.message === "User created successfully"
  //       ) {
  //         // Optional: log them in or just redirect
  //         setMessage("Registrasi berhasil. Selamat datang!");
  //         localStorage.removeItem("pendingRegisterData");
  //         navigate("/");
  //       } else {
  //         setErrorMessage(
  //           registerResponse.data.message || "Gagal menyimpan data user."
  //         );
  //       }
  //     } else {
  //       setErrorMessage("OTP tidak valid atau telah kedaluwarsa.");
  //     }
  //   } catch (error) {
  //     console.error("Error verifying OTP & register:", error);
  //     setErrorMessage("Terjadi kesalahan saat memverifikasi atau registrasi.");
  //   }
  // };

  // const handleVerifyOtp = async (otpString) => {
  //   const emailToVerify = state?.email || localStorage.getItem("pendingEmail");

  //   if (!emailToVerify) {
  //     setErrorMessage("Email tidak ditemukan. Silakan daftar ulang.");
  //     return;
  //   }

  //   try {
  //     // Step 1: Verify OTP only
  //     const verifyResponse = await apiClient.post("/user/verify-otp", {
  //       email: emailToVerify,
  //       otp: otpString,
  //     });

  //     if (verifyResponse.data && verifyResponse.data.success) {
  //       // Step 2: Register user (now that OTP is verified)
  //       const formData = JSON.parse(
  //         localStorage.getItem("pendingRegisterData")
  //       );

  //       if (!formData) {
  //         setErrorMessage(
  //           "Data registrasi tidak ditemukan. Silakan daftar ulang."
  //         );
  //         return;
  //       }

  //       const registerResponse = await apiClient.post(
  //         "/user/register",
  //         formData
  //       );

  //       if (
  //         registerResponse.data &&
  //         registerResponse.data.message === "User created successfully"
  //       ) {
  //         // Step 3: Login
  //         const loginResponse = await apiClient.post("/user/login", {
  //           email: emailToVerify,
  //           password: formData.password,
  //         });

  //         if (loginResponse.data.token) {
  //           localStorage.setItem("token", loginResponse.data.token);
  //           localStorage.setItem("userId", loginResponse.data.userId);
  //           localStorage.removeItem("pendingRegisterData");

  //           toast.success("Registrasi & login berhasil!", { autoClose: 2000 });
  //           navigate("/");
  //         } else {
  //           setErrorMessage("Registrasi berhasil, tapi login gagal.");
  //         }
  //       } else {
  //         setErrorMessage("Gagal membuat akun. Silakan coba lagi.");
  //       }
  //     } else {
  //       setErrorMessage(verifyResponse.data.message || "OTP tidak valid.");
  //     }
  //   } catch (error) {
  //     console.error("Error verifying OTP or creating user:", error);
  //     setErrorMessage("Terjadi kesalahan saat verifikasi atau registrasi.");
  //   }
  // };



  const handleVerifyOtp = async (otpString) => {
  const emailToVerify = state?.email || localStorage.getItem("pendingEmail");

  if (!emailToVerify) {
    setErrorMessage("Email tidak ditemukan. Silakan daftar ulang.");
    return;
  }

  try {
    // Step 1: Verify OTP
    const verifyResponse = await apiClient.post("/user/verify-otp", {
      email: emailToVerify,
      otp: otpString,
    });

    if (!verifyResponse.data?.success) {
      setErrorMessage(verifyResponse.data.message || "OTP tidak valid.");
      return;
    }

    // Step 2: Try Login first
    const formData = JSON.parse(localStorage.getItem("pendingRegisterData"));
console.log("Form data from localStorage:", formData); // Debug log for form data
    if (!formData) {
      setErrorMessage("Data registrasi tidak ditemukan. Silakan daftar ulang.");
      return;
    }

    try {
      const loginResponse = await apiClient.post("/user/login", {
        email: emailToVerify,
        password: formData.password,
      });

      if (loginResponse.data.token) {
        localStorage.setItem("token", loginResponse.data.token);
        localStorage.setItem("userId", loginResponse.data.userId);
        localStorage.removeItem("pendingRegisterData");

        toast.success("Login berhasil!", { autoClose: 2000 });
        navigate("/");
        return;
      }
    } catch (loginError) {
      // Step 3: If login fails because user not found, register them
      const loginMessage = loginError?.response?.data?.message;

      if (loginMessage === "Email tidak ditemukan") {
        const registerResponse = await apiClient.post("/user/register", formData);
console.log("Register response:", registerResponse.data); // Debug log for registration response
        if (
          registerResponse.data?.message === "User created successfully"
        ) {
          // Try login again after successful registration
          const loginAfterRegister = await apiClient.post("/user/login", {
            email: emailToVerify,
            password: formData.password,
          });

          if (loginAfterRegister.data.token) {
            localStorage.setItem("token", loginAfterRegister.data.token);
            localStorage.setItem("userId", loginAfterRegister.data.userId);
            localStorage.removeItem("pendingRegisterData");

            toast.success("Registrasi & login berhasil!", { autoClose: 2000 });
            navigate("/");
            return;
          }
        } else {
          // setErrorMessage("Gagal membuat akun. Silakan coba lagi.");
          toast.success("Registrasi & login berhasil!", { autoClose: 2000 });
            navigate("/login");
            return;
        }
      } else {
        setErrorMessage("Login gagal. Coba lagi.");
      }
    }
  } catch (error) {
    console.error("Error verifying OTP or login/register:", error);
    setErrorMessage("Terjadi kesalahan saat verifikasi atau login.");
  }
};






  const handleResendOtp = async () => {
    try {
      await apiClient.post("/user/resend-otp", {
        email: state.email,
      });
      setTimer(60); // Reset the timer after sending OTP
    } catch (error) {
      console.error("Error resending OTP:", error);
      setErrorMessage("Terjadi kesalahan saat mengirim ulang OTP.");
    }
  };

  // return (
  //   <Container component="main" maxWidth="xs">
  //     <Box
  //       sx={{
  //         display: 'flex',
  //         flexDirection: 'column',
  //         alignItems: 'center',
  //         justifyContent: 'center',
  //         height: '100vh',
  //       }}
  //     >
  //       <Typography variant="h5" sx={{ fontFamily: 'Inter', fontWeight: 900, fontSize: '36px', textAlign: 'center', marginBottom: 2 }}>
  //         Verification Code
  //       </Typography>

  //       <Typography sx={{ fontFamily: 'Inter', width: '190%', fontWeight: 400, fontSize: '24px', textAlign: 'center', marginBottom: 2 }}>
  //         Verification code has been sent to {state.email}
  //       </Typography>

  //       <Box sx={{ display: 'flex', gap: 2, marginBottom: 4 }}>
  //         {otp.map((digit, index) => (
  //           <TextField
  //             key={index}
  //             id={`otp-input-${index}`}
  //             type="text"
  //             inputProps={{ maxLength: 1 }}
  //             value={digit}
  //             onChange={(e) => handleOtpChange(e, index)}
  //             onKeyDown={(e) => handleOtpChange(e, index)} // Handle backspace for clearing
  //             variant="standard" // Use the 'standard' variant for the underline style
  //             sx={{
  //               '& .MuiInputBase-root': {
  //                 padding: 0, // Remove extra padding
  //               },
  //               '& .MuiInputBase-input': {
  //                 textAlign: 'center',
  //                 fontSize: '64px',
  //                 fontWeight: 700,
  //                 fontFamily: 'Inter',
  //               },
  //               '& .MuiInput-underline:before': {
  //                 borderBottom: '2px solid #BDBDBD', // Default underline color
  //               },
  //               '& .MuiInput-underline:hover:before': {
  //                 borderBottom: '2px solid #1F1F1F', // Hover effect for underline
  //               },
  //             }}
  //             required
  //           />
  //         ))}
  //       </Box>

  //       <Typography sx={{ fontFamily: 'Inter', width: '180%', fontWeight: 400, fontSize: '24px', textAlign: 'center', marginBottom: 2 }}>
  //         Please wait <span style={{ fontWeight: 700 }}>{timer} second</span> to resend OTP.
  //       </Typography>

  //       {timer === 0 && (
  //         <Button
  //           onClick={handleResendOtp}
  //           variant="contained"
  //           color="secondary"
  //           fullWidth
  //           sx={{
  //             height: '56px',
  //             backgroundColor: '#1F1F1F',
  //             color: 'white',
  //             mb: 6,
  //             fontFamily: 'Inter',
  //             fontWeight: 700,
  //             fontSize: '24px',
  //           }}
  //         >
  //           RESEND OTP
  //         </Button>
  //       )}

  //       {errorMessage && <Typography color="error">{errorMessage}</Typography>}
  //     </Box>
  //   </Container>
  // );

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4 bg-gray-100">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-6 space-y-6">
        <h1 className="text-3xl md:text-4xl font-extrabold text-center text-gray-900">
          Verification Code
        </h1>

        <p className="text-lg md:text-xl text-center text-gray-700">
          Verification code has been sent to{" "}
          {/* <span className="font-semibold">{state.email}</span> */}
        </p>

        {/* OTP Inputs */}
        <div className="flex justify-center gap-3 md:gap-4">
          {otp.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleOtpChange(e, index)}
              onKeyDown={(e) => handleOtpKeyDown(e, index)}
              ref={(el) => (inputRefs.current[index] = el)}
              className="w-14 h-16 text-4xl text-center font-bold border-b-4 border-gray-300 focus:outline-none focus:border-black transition-all duration-150"
            />
          ))}
        </div>

        <p className="text-lg md:text-xl text-center text-gray-700">
          Please wait <span className="font-bold">{timer} second</span> to
          resend OTP.
        </p>

        {timer === 0 && (
          <button
            onClick={handleResendOtp}
            className="w-full py-3 bg-black text-white font-bold text-lg rounded-md hover:bg-gray-800 transition"
          >
            RESEND OTP
          </button>
        )}

        {errorMessage && (
          <p className="text-red-600 text-center">{errorMessage}</p>
        )}
      </div>
    </div>
  );
};

export default OtpVerification;
